import { render } from "./SupportServView.vue?vue&type=template&id=8a7d9f6e&scoped=true"
import script from "./SupportServView.vue?vue&type=script&lang=js"
export * from "./SupportServView.vue?vue&type=script&lang=js"

import "./SupportServView.vue?vue&type=style&index=0&id=8a7d9f6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a7d9f6e"]])

export default __exports__